const BUILDER_ESTIMATOR_ROUTE_NAME = "BuilderEstimator";

export default BUILDER_ESTIMATOR_ROUTE_NAME;
